import { LineType } from "./lineType";

export const LINETYPEKEYS = [
    { Key: LineType.Linear, Display: 'i18n:LINETYPES.LINEAR' },
    { Key: LineType.Natural, Display: 'i18n:LINETYPES.NATURAL' },
    { Key: LineType.StepLine, Display: 'i18n:LINETYPES.STEPLINE' },
    { Key: LineType.StepLineBefore, Display: 'i18n:LINETYPES.STEPLINEBEFORE' },
    { Key: LineType.StepLineAfter, Display: 'i18n:LINETYPES.STEPLINEAFTER' },
    { Key: LineType.MonotoneX, Display: 'i18n:LINETYPES.MONOTONEX' },
  ];